import dom_slider from './dom-slider';

const {slideToggle, slideUp, slideDown} = window.domSlider;

(function (Drupal, once) {
	Drupal.behaviors.mainMenuBehavior = {
	  attach: function (context, settings) {
		once('mainMenuBehavior', 'html', context).forEach( function (element) {
			function initSlideCSwitcherMobile() {
				const links = document.querySelectorAll("#bottom-header .dropdown-toggle");
				for (let i = 0; i < links.length; i++) {
					links[i].addEventListener('click', function (e) {
						const target = e.target;
						
						if (!target.closest('.dropdown-toggle')) return;
						if (target.closest('#top-header')) return;

						e.preventDefault();
						const link = this;
						link.classList.add("show-menu");
						const ddel = link.nextElementSibling;	
						for (let i = 0; i < links.length; i++) {
							let openddel = links[i].nextElementSibling;
							if (!openddel.classList.contains('DOM-slider-hidden')) {
								slideToggle({
									element: openddel,
									slideSpeed: 300,
									easing: 'ease',
									delay: 0
								}).then(() => {		
									links[i].classList.remove("show-menu");  
								});
							}
						};
						slideToggle({
							element: ddel,
							slideSpeed: 300,
							easing: 'ease',
							delay: 0
						}).then(() => {
							if (ddel.classList.contains('DOM-slider-hidden')) {
								link.classList.remove("show-menu");  
							} else {
								link.classList.add("show-menu");		
							}
						});
					});
				}
			};

			if (document.body.classList.contains('user-logged-in')) {
				let i = 0;
				let csb = setInterval(function() {
					if (document.querySelector('#bottom-header .country-name')){
						clearInterval(csb);
						initSlideCSwitcherMobile();
					}
					if (i > 20) {
						clearInterval(csb);
						initSlideCSwitcherMobile();
					  }
					i++;
				}, 100);
			} else {
				initSlideCSwitcherMobile();
			}	

			var mainDropLinks = document.querySelectorAll(".main-menu .dropdown");
			Array.from(mainDropLinks).forEach(target => {
				target.addEventListener("mouseover", function( event ) { 
					event.target.closest('.nav').classList.add('dropdown-hover');
				}, false);
				target.addEventListener("mouseout", function( event ) {
					event.target.closest('.nav').classList.remove("dropdown-hover");
				}, false);
			});
			
			var innerDropLinks = document.querySelectorAll(".inner-column-menu .inner-dropdown-menu");	
			Array.from(innerDropLinks).forEach(target => {
				target.addEventListener("mouseover", function( event ) { 
					event.target.closest('.inner-column-menu').classList.add('inner-dropdown-hover');
				}, false);
				target.addEventListener("mouseout", function( event ) {
					event.target.closest('.inner-column-menu').classList.remove("inner-dropdown-hover");			
				}, false);
			});			
		})
	  }
	}
  } (Drupal, once));